import script from "./menu.vue?vue&type=script&setup=true&lang=ts"
export * from "./menu.vue?vue&type=script&setup=true&lang=ts"

import "./menu.vue?vue&type=style&index=0&id=effbcb7c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-effbcb7c"]])

export default __exports__